export default __webpack_public_path__ + "static/media/hitch_float_mode_white.7e76f469.svg";